import React from 'react';
import isEmpty from 'lodash/isEmpty';
import {
  AdditionalTermsAndConditionsToolTip,
  AddOfficialRulesToolTip,
  AddSponsorLegalToolTip,
  ApproxValueAllPrizesToolTip,
  CustomTermsAndConditionsToolTip,
  GrandPrizeToolTip,
  NumberOfPrizesToolTip,
  RunnerUpToolTip,
  SetEndDayToolTip,
  SetStartDayToolTip,
  StepControllingSweepsToolTip,
  WeeklyPrizeDateLegalToolTip,
  WeeklyPrizeToolTip,
  BreakSponsorNameToolTip
} from "components/break/tooltips/breaks-prizing-info-tool-tips";
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    key: "breaksPrizingInformation",
    showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored'),
    props: {
        headerKey: 'editbreak.section.prizing.heading'
    },

    fields: [
        {
            type: "text",
            name: "instantWinId",

            props: {
                labelKey: "Instant Win Id",
            }
        },
        {
            type: "breakStepDropdown",
            name: "prizingTiedStep",
            required: false,
            props: {
                labelKey: "editbreak.breaksPrizingInformation.prizingTiedStep",
                helpContent: <StepControllingSweepsToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.prizingTiedStep'}/></IntlProvider>,
                validationRules: [
                  {
                    type: 'StepExists'
                  }
                ]
            }
        },
        {
            name: 'setSweepsDate',
            conditionalSection: true,
            showField: formProxy => !isEmpty(formProxy.currentResource.prizingTiedStep),
            required: true,

            props: {
                labelKey: "editbreak.breaksPrizingInformation.sweepstakesDateTime"
            },

            fields: [
                {
                    name: 'setSweepsStartDate',
                    conditionalSection: true,
                    props: {
                        labelKey: "editbreak.breaksPrizingInformation.sweepstakesStartDate",
                        helpContent: <SetStartDayToolTip/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.sweepstakesStartDate'}/></IntlProvider>
                    },

                    fields: [
                        {
                            type: "datetime",
                            name: "sweepstakesStartDate"
                        }
                    ]
                },
                {
                    name: 'setSweepsEndDate',
                    conditionalSection: true,
                    props: {
                        labelKey: "editbreak.breaksPrizingInformation.sweepstakesEndDate",
                        helpContent: <SetEndDayToolTip/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.sweepstakesEndDate'}/></IntlProvider>
                    },

                    fields: [
                        {
                            type: "datetime",
                            name: "sweepstakesEndDate"
                        }
                    ]
                }
            ]
        },
        {
            type: "text",
            name: "grandPrizeId",

            props: {
                labelKey: "editbreak.breaksPrizingInformation.grandPrizeId",
                helpContent: <GrandPrizeToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.grandPrizeId'}/></IntlProvider>
            }
        },
        {
            type: "text",
            name: "runnerupPrizeId",

            props: {
                labelKey: "editbreak.breaksPrizingInformation.runnerupPrizeId",
                helpContent: <RunnerUpToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.runnerupPrizeId'}/></IntlProvider>
            }
        },
        {
            type: "text",
            name: "weeklyPrizeId",

            props: {
                labelKey: "editbreak.breaksPrizingInformation.weeklyPrizeId",
                helpContent: <WeeklyPrizeToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.weeklyPrizeId'}/></IntlProvider>
            }
        },
        {
            name: 'addWeeklyPrizeDateToLegal',
            conditionalSection: true,
            showField: formProxy => !isEmpty(formProxy.currentResource.weeklyPrizeId),
            props: {
                labelKey: "editbreak.breaksPrizingInformation.weeklyPrizeAwardDates",
                helpContent: <WeeklyPrizeDateLegalToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.weeklyPrizeAwardDates'}/></IntlProvider>
            },

            fields: [
                {
                    type: "datetime",
                    name: "weeklyPrizeAwardDates"
                }
            ]
        },
        {
            type: "number",
            name: "numberOfPrizes",
            required: false,

            props: {
                labelKey: "editbreak.breaksPrizingInformation.numberOfPrizes",
                helpContent: <NumberOfPrizesToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.numberOfPrizes'}/></IntlProvider>,
                validationRules: [
                    {
                        type: "NumberFormat"
                    }
                ]
            }
        },
        {
            type: "currency",
            name: "approximateRetailValueOfPrizes",
            required: false,

            props: {
                labelKey: "editbreak.breaksPrizingInformation.approximateRetailValueOfPrizes",
                helpContent: <ApproxValueAllPrizesToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.approximateRetailValueOfPrizes'}/></IntlProvider>
            }
        },
        {
            type: "text",
            name: "sponsor",

            props: {
                labelKey: "editbreak.breaksPrizingInformation.addSponsorToLegal",
                helpContent: <AddSponsorLegalToolTip />,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id="editbreak.breaksPrizingInformation.addSponsorToLegal" /></IntlProvider>
            }
        },
        {
            name: 'useCustomAbbreviatedTermsAndConditions',
            conditionalSection: true,
            required: true,
            props: {
                labelKey: "editbreak.breaksPrizingInformation.useCustomAbbreviatedTerms",
                helpContent: <CustomTermsAndConditionsToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.customAbbreviatedTerms'}/></IntlProvider>
            },

            fields: [
                {
                    type: "contenteditable",
                    name: "customAbbreviatedTerms",
                    props: {
                        labelKey: "editbreak.breaksPrizingInformation.customAbbreviatedTerms"
                    }
                }
            ]
        },
        {
            name: 'addAdditionalTermsAndConditions',
            conditionalSection: true,
            required: true,
            props: {
                labelKey: "editbreak.breaksPrizingInformation.addTermsAndConditions",
                helpContent: <AdditionalTermsAndConditionsToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.termsAndConditions'}/></IntlProvider>,
                validationRules: [
                  {
                    type: 'NANDGate',
                    params: {
                      field: 'addAdditionalTermsAndConditions',
                      otherField: 'addFullOfficialRules'
                    }
                  }
                ]
            },
            fields: [
                {
                    type: "text",
                    name: "termsAndConditions",

                    props: {
                        labelKey: "editbreak.breaksPrizingInformation.termsAndConditions"
                    }
                }
            ]
        },
        {
            name: 'addFullOfficialRules',
            conditionalSection: true,
            required: true,
            props: {
                labelKey: "editbreak.breaksPrizingInformation.addFullOfficialRules",
                helpContent: <AddOfficialRulesToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksPrizingInformation.fullOfficialRules'}/></IntlProvider>,
                validationRules: [
                  {
                    type: 'NANDGate',
                    params: {
                      field: 'addFullOfficialRules',
                      otherField: 'addAdditionalTermsAndConditions'
                    }
                  }
                ]
            },

            fields: [
                {
                    type: "contenteditable",
                    name: "fullOfficialRules",

                    props: {
                        labelKey: "editbreak.breaksPrizingInformation.fullOfficialRules"
                    }
                }
            ]
        },
        {
            type: 'text',
            name: 'customSponsor',
            showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored'),
            props: {
                labelKey: 'editbreak.general.sponsorName',
                helpContent: <BreakSponsorNameToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.sponsorName'}/></IntlProvider>,
                placeholderKey: 'editbreak.general.sponsorName.placeholder'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksPrizingInformation.js